<template>
    <div class="base_box_main pt-4 pb-4">
        <div class="container-fluid">
            <div class="row card-deck homegrid">

                <schedules-card v-if="schedules"></schedules-card>

                <pricing-card v-if="pricing"></pricing-card>

                <settings-card v-if="settings"></settings-card>

                <transporters-card v-if="transporters"></transporters-card>

                <users-card v-if="users"></users-card>

                <reports-card v-if="reports"></reports-card>

                <dispatching-card v-if="dispatching"></dispatching-card>

                <sales-card v-if="sales"></sales-card>

                <profile-card v-if="profile"></profile-card>

                <logs-card v-if="logs"></logs-card>

<!--                <cru-table model="buses"></cru-table>-->
<!--                <cru-table :model="model"></cru-table>-->
            </div>
        </div>
    </div>
</template>

<script>
    import SchedulesCard from './cards/SchedulesCard';
    import PricingCard from './cards/PricingCard';
    import SettingsCard from './cards/SettingsCard';
    import TransportersCard from './cards/TransportersCard';
    import UsersCard from './cards/UsersCard';
    import ReportsCard from './cards/ReportsCard';
    import DispatchingCard from './cards/DispatchingCard';
    import SalesCard from './cards/SalesCard';
    import ProfileCard from './cards/ProfileCard';
    import LogsCard from './cards/LogsCard';
    import CruTable from "../../components/CruTable";
    // import Bus from '../../crudables/Bus'

    export default {
        components: {
            CruTable,
            SchedulesCard,
            PricingCard,
            SettingsCard,
            TransportersCard,
            UsersCard,
            ReportsCard,
            DispatchingCard,
            SalesCard,
            ProfileCard,
            LogsCard
        },
        props: {
            schedules: Boolean,
            users: Boolean,
            profile: Boolean,
            dispatching: Boolean,
            sales: Boolean,
            pricing: Boolean,
            settings: Boolean,
            transporters: Boolean,
            reports: Boolean,
            logs: Boolean,
        },
        data(){
            return {
                // model: Bus
            }
        }
    }
</script>

<style scoped>

</style>
